<template>
    <div v-if="model">
        <el-form ref="form" :model="model" :rules="rules" label-width="120px" label-position="top" size="mini">
            <el-form-item label="指标名称" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="统计类型" prop="type">
                <el-select v-model="model.type" @change="onTypeChange">
                    <el-option v-for="item in statTypes" :key="item.value" :value="item.value"
                               :label="item.label"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div v-if="model.termsStatConfig">
            <el-form ref="termsStatConfigForm" :model="model.termsStatConfig" :rules="termsStatConfigRules"
                     label-width="120px" label-position="top" size="mini">
                <el-form-item label="数据源" prop="datasource" v-if="!subStat">
                    <datasource-select v-model="model.termsStatConfig.datasource"></datasource-select>
                </el-form-item>
                <el-form-item label="时间字段" prop="timeField" v-if="!subStat">
                    <el-input v-model="model.termsStatConfig.timeField"></el-input>
                </el-form-item>
                <el-form-item label="检索条件" prop="queryConfig" v-if="model.termsStatConfig.datasource">
                    <es-query-editor v-model="model.termsStatConfig.queryConfig" :data-source-id="model.termsStatConfig.datasource.id"></es-query-editor>
                </el-form-item>
                <el-form-item label="分类字段" prop="termField">
                    <el-input v-model="model.termsStatConfig.termField"></el-input>
                </el-form-item>
                <el-form-item label="最大个数" prop="limit">
                    <el-input type="number" v-model.number="model.termsStatConfig.limit"></el-input>
                </el-form-item>
                <el-form-item label="排序方式" prop="sortType">
                    <el-select v-model="model.termsStatConfig.sortType">
                        <el-option v-for="item in termSortTypes" :key="item.value" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包含的值列表" prop="includeValues">
                    <el-select
                            v-model="model.termsStatConfig.includeValues"
                            multiple
                            filterable
                            allow-create
                            default-first-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排除的值列表" prop="excludeValues">
                    <el-select
                            v-model="model.termsStatConfig.excludeValues"
                            multiple
                            filterable
                            allow-create
                            default-first-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开启子统计">
                    <el-switch :value="Boolean(model.termsStatConfig.subDimensionConfig)"
                               @input="enableSubStat(model.termsStatConfig, $event)"
                               active-color="#13ce66"
                               inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
            </el-form>
            <stat-dimension-config-form class="sub-config" v-if="model.termsStatConfig.subDimensionConfig"
                                        ref="termsStatConfigSubForm"
                                        v-model="model.termsStatConfig.subDimensionConfig"
                                        sub-stat></stat-dimension-config-form>
        </div>

        <div v-if="model.dateStatConfig">
            <el-form ref="dateStatConfigForm" :model="model.dateStatConfig" :rules="dateStatConfigRules"
                     label-width="120px" label-position="top" size="mini">
                <el-form-item label="数据源" prop="datasource" v-if="!subStat">
                    <datasource-select v-model="model.dateStatConfig.datasource"></datasource-select>
                </el-form-item>
                <el-form-item label="时间字段" prop="timeField" v-if="!subStat">
                    <el-input v-model="model.dateStatConfig.timeField"></el-input>
                </el-form-item>
                <el-form-item label="检索条件" prop="queryConfig" v-if="!subStat && model.dateStatConfig.datasource">
                    <es-query-editor v-model="model.dateStatConfig.queryConfig" :data-source-id="model.dateStatConfig.datasource.id"></es-query-editor>
                </el-form-item>
            </el-form>
        </div>

        <div v-if="model.customStatConfig">
            <el-form ref="customStatConfigForm" :model="model.customStatConfig" :rules="customStatConfigRules"
                     label-width="120px" label-position="top" size="mini">
                <el-form-item label="排序方式" prop="sortType">
                    <el-select v-model="model.customStatConfig.sortType">
                        <el-option v-for="item in customSortTypes" :key="item.value" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addCustomValueConfig">添加维度</el-button>
                </el-form-item>
            </el-form>
            <div v-for="(valueConfig,index) in model.customStatConfig.valueConfigs" :key="index">
                <el-form ref="valueConfigForm" :model="valueConfig" :rules="valueConfigRules" label-width="120px"
                         label-position="top" size="mini">
                    <el-form-item label="维度名称" prop="name">
                        <el-input v-model="valueConfig.name"></el-input>
                    </el-form-item>
                    <el-form-item label="数据源" prop="datasource" v-if="!subStat">
                        <datasource-select v-model="valueConfig.datasource"></datasource-select>
                    </el-form-item>
                    <el-form-item label="时间字段" prop="timeField" v-if="!subStat">
                        <el-input v-model="valueConfig.timeField"></el-input>
                    </el-form-item>
                    <el-form-item label="检索条件" prop="queryConfig" v-if="valueConfig.datasource">
                        <es-query-editor v-model="valueConfig.queryConfig" :data-source-id="valueConfig.datasource.id"></es-query-editor>
                    </el-form-item>
                    <el-form-item label="开启子统计">
                        <el-switch :value="Boolean(valueConfig.subDimensionConfig)"
                                   @input="enableSubStat(valueConfig, $event)"
                                   active-color="#13ce66"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="removeCustomValueConfig(index)">删除维度</el-button>
                    </el-form-item>
                </el-form>
                <stat-dimension-config-form class="sub-config" v-if="valueConfig.subDimensionConfig" ref="valueConfigSubStatForm"
                                            v-model="valueConfig.subDimensionConfig"
                                            sub-stat></stat-dimension-config-form>
            </div>
        </div>


    </div>
</template>

<script>
    import DatasourceSelect from '../common/DatasourceSelect'
    import StatDimensionConfigForm from './StatDimensionConfigForm'
    import {buildQueryFromQueryConfig} from '../../service/EsQueryUtils'
    import EsQueryEditor from "../common/EsQueryEditor"

    const statTypes = [
        {value: 'terms', label: '分类统计'},
        {value: 'date', label: '时间统计'},
        {value: 'custom', label: '自定义'},
    ]
    const termSortTypes = [
        {value: 'desc', label: '降序'},
        {value: 'asc', label: '升序'},
    ]

    const customSortTypes = [
        {value: 'desc', label: '降序'},
        {value: 'asc', label: '升序'},
        {value: 'custom', label: '配置顺序'},
    ]
    export default {
        name: "StatDimensionConfigForm",
        components: {DatasourceSelect, StatDimensionConfigForm, EsQueryEditor},
        props: {
            value: Object,
            subStat: {
                type: Boolean,
                default: false
            }
        },
        data() {
            const checkQueryConfig = (rule, value, callback) => {
                if (value) {
                    const query = buildQueryFromQueryConfig(value)
                    if(query&&query.length>10000){
                        callback(new Error('长度不能超过 10000 个字符'))
                    }else{
                        callback()
                    }
                } else {
                    callback();
                }
            }
            return {
                statTypes,
                termSortTypes,
                customSortTypes,
                model: this.value ? this.preprocessModel(JSON.parse(JSON.stringify(this.value))) : {
                    name: null,
                    type: null,
                    termsStatConfig: null,
                    dateStatConfig: null,
                    customStatConfig: null
                },
                rules: {
                    name: [
                        {required: true, message: '请输入指标名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择统计类型', trigger: 'blur'}
                    ]
                },
                termsStatConfigRules: {
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'}
                    ],
                    timeField: [
                        {required: true, message: '请输入时间字段名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    queryConfig: [
                        {validator: checkQueryConfig, trigger: 'blur'}
                    ],
                    termField: [
                        {required: true, message: '请输入分类字段名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    limit: [
                        {required: true, message: '请输入最大个数', trigger: 'blur'},
                        {type: 'integer', min: 1, message: '必须大于0', trigger: 'blur'},
                    ],
                    sortType: [
                        {required: true, message: '请选择排序方式', trigger: 'blur'}
                    ]
                },
                dateStatConfigRules: {
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'}
                    ],
                    timeField: [
                        {required: true, message: '请输入时间字段名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    queryConfig: [
                        {validator: checkQueryConfig, trigger: 'blur'}
                    ],
                },
                customStatConfigRules: {
                    sortType: [
                        {required: true, message: '请选择排序方式', trigger: 'blur'}
                    ]
                },
                valueConfigRules: {
                    name: [
                        {required: true, message: '请输入维度名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'}
                    ],
                    timeField: [
                        {required: true, message: '请输入时间字段名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    queryConfig: [
                        {validator: checkQueryConfig, trigger: 'blur'}
                    ]
                },
            }
        },
        watch: {
            value(newValue) {
                const newValueJson = JSON.stringify(newValue)
                if (newValueJson === JSON.stringify(this.model)) {
                    return
                }
                this.model = this.preprocessModel(JSON.parse(newValueJson))
            },
            model: {
                handler(newValue, oldValue) {
                    // 只有model引用不变而内容发生变化时才触发input事件
                    if (newValue === oldValue) {
                        this.$emit('input', JSON.parse(JSON.stringify(this.postprocessModel(this.model))))
                    }
                },
                deep: true
            }
        },
        methods: {
            preprocessModel(model){
                if(!model){
                    return model
                }
                if(model.termsStatConfig){
                    if(!model.termsStatConfig.queryConfig){
                        model.termsStatConfig.queryConfig = model.termsStatConfig.query
                    }
                }
                if(model.dateStatConfig){
                    if(!model.dateStatConfig.queryConfig){
                        model.dateStatConfig.queryConfig = model.dateStatConfig.query
                    }
                }
                if(model.customStatConfig){
                    for(const valueConfig of model.customStatConfig.valueConfigs){
                        if(!valueConfig.queryConfig){
                            valueConfig.queryConfig = valueConfig.query
                        }
                    }
                }
                return model
            },
            postprocessModel(model){
                if(!model){
                    return model
                }
                if(model.termsStatConfig){
                    model.termsStatConfig.query = buildQueryFromQueryConfig(model.termsStatConfig.queryConfig)
                }
                if(model.dateStatConfig){
                    model.dateStatConfig.query = buildQueryFromQueryConfig(model.dateStatConfig.queryConfig)
                }
                if(model.customStatConfig){
                    for(const valueConfig of model.customStatConfig.valueConfigs){
                        valueConfig.query = buildQueryFromQueryConfig(valueConfig.queryConfig)
                    }
                }
                return model
            },
            addCustomValueConfig() {
                const newValueConfig = {
                    name: null,
                    datasource: null,
                    query: null,
                    queryConfig: null,
                    timeField: null,
                    subDimensionConfig: null
                }
                if (this.model.customStatConfig.valueConfigs) {
                    this.model.customStatConfig.valueConfigs.push(newValueConfig)
                } else {
                    this.model.customStatConfig.valueConfigs = [newValueConfig]
                }
            },
            removeCustomValueConfig(index) {
                this.model.customStatConfig.valueConfigs.splice(index, 1)
            },
            enableSubStat(config, enabled) {
                if (enabled) {
                    config.subDimensionConfig = {
                        type: 'terms',
                        termsStatConfig: {
                            termField: null,
                            limit: null,
                            includeValues: null,
                            excludeValues: null,
                            sortType: null,
                            subDimensionConfig: null
                        },
                        dateStatConfig: null,
                        customStatConfig: null
                    }
                } else {
                    config.subDimensionConfig = null
                }
            },
            validate() {
                const validatePromises = []
                validatePromises.push(this.$refs.form.validate())
                if (this.$refs.termsStatConfigForm) {
                    validatePromises.push(this.$refs.termsStatConfigForm.validate())
                }
                if (this.$refs.termsStatConfigSubForm) {
                    validatePromises.push(this.$refs.termsStatConfigSubForm.validate())
                }
                if (this.$refs.dateStatConfigForm) {
                    validatePromises.push(this.$refs.dateStatConfigForm.validate())
                }
                if (this.$refs.customStatConfigForm) {
                    validatePromises.push(this.$refs.customStatConfigForm.validate())
                }
                if (Array.isArray(this.$refs.valueConfigForm)) {
                    validatePromises.push(...this.$refs.valueConfigForm.map(form => form.validate()))
                } else if (this.$refs.valueConfigForm) {
                    validatePromises.push(this.$refs.valueConfigForm.validate())
                }
                if (Array.isArray(this.$refs.valueConfigSubStatForm)) {
                    validatePromises.push(...this.$refs.valueConfigSubStatForm.map(form => form.validate()))
                } else if (this.$refs.valueConfigSubStatForm) {
                    validatePromises.push(this.$refs.valueConfigSubStatForm.validate())
                }
                return Promise.all(validatePromises)
            },
            onTypeChange(newType) {
                if (newType === 'terms') {
                    this.model.dateStatConfig = null
                    this.model.customStatConfig = null
                    this.model.termsStatConfig = {
                        datasource: null,
                        query: null,
                        queryConfig: null,
                        timeField: null,
                        termField: null,
                        limit: null,
                        includeValues: null,
                        excludeValues: null,
                        sortType: null,
                        subDimensionConfig: null
                    }
                } else if (newType === 'date') {
                    this.model.termsStatConfig = null
                    this.model.customStatConfig = null
                    this.model.dateStatConfig = {
                        datasource: null,
                        query: null,
                        queryConfig: null,
                        timeField: null,
                    }
                } else if (newType === 'custom') {
                    this.model.termsStatConfig = null
                    this.model.dateStatConfig = null
                    this.model.customStatConfig = {
                        sortType: null,
                        valueConfigs: null,
                    }
                }
            }
        }
    }
</script>

<style scoped>
.sub-config{
    margin-left: 20px;
    border-left: 2px #5182E4 solid;
    padding-left: 10px;
}
</style>
